import { formatNumber } from 'libphonenumber-js';

export default {
  name: 'mobileformat',
  process: (mobileNumber, countryCode, type = 'NATIONAL') => {
    const number = countryCode ? `+${countryCode}${mobileNumber}` : `+91${mobileNumber}`;
    const formattedNumber = formatNumber(number, type);
    return formattedNumber === '' ? mobileNumber : formattedNumber;
  }
};
